/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import PropTypes from 'prop-types';

import Icon from '@components/shared/icons';

import './promptForTitleModal.scss';
import TitleIconLong from '@images/title-icon-long.png';
import Angie from '@images/angie-avatar.png';
import Fetch from '@components/util/Fetch';
import { logCrmEvent } from '@javascripts/util/eventLogging';
import { useTitleConsent } from '@components/TitleMatches/TitleConsent';

function stopPropagation(e) {
  e.stopPropagation();
}

const PromptForTitleModal = (props) => {
  const {
    show = false,
    acceptClose = () => {},
    dismissClose = () => {},
    matchId,
    matchUuid,
    noteStatusId,
  } = props;

  const { go } = useTitleConsent();

  const pledgeTitle = () => {
    go(`/title_matches/pledge/new/${matchUuid}`);

    acceptClose();
  };

  const dismissTitleServices = () => {
    dismissClose();
    logCrmEvent(
      'disruptor_dismissed',
      {
        type: 'ress_contact_request_from_agent_status_update',
        note_status_id: noteStatusId,
        match_id: matchId,
      }
    );
  };

  const modalClasslist = ['notify-loop-title-prompt-modal-container'];

  if (show) {
    modalClasslist.push('show');
  }

  return (
    <div
      id="notify-loop-title-prompt-modal"
      role="button"
      tabIndex={0}
      onMouseDown={dismissTitleServices}
      className={modalClasslist.join(' ')}
    >
      <div
        className="notify-loop-title-prompt-modal"
        role="button"
        tabIndex={0}
        onMouseDown={stopPropagation}
      >
        <button
          type="button"
          className="close-button"
          onClick={dismissTitleServices}
        >
          <i className="times" />
        </button>
        <div className="content-wrapper">
          <div
            id="title-prompt-modal-button"
            className="notify-loop-title-services"
          >
            <div className="title-left">
              <img src={TitleIconLong} alt="Title Icon" />
              <h2 className="title-prompt-header">
                Let us take care of this closing for you!
              </h2>
            </div>
            <div className="title-right">
              <div className="title-avatar">
                <img
                  alt="angie-avatar"
                  src={Angie}
                  className="title-avatar"
                />
              </div>
              <div className="small-bold-font">
                Angie Murph
              </div>
              <div className="small-font">
                <i className="phone" />
                <span>(941) 302-2977</span>
              </div>
            </div>
          </div>
          <p className="title-prompt-text">
            ReferralExchange can now&nbsp;
            <b>streamline your referral&apos;s closing</b>
            &nbsp;
            with our in-house settlement services - we offer the high-touch
            service you&apos;re used to and very competitive pricing.
          </p>
          <div className="button-container">
            <button
              type="button"
              className="profile-edit-button title"
              onClick={pledgeTitle}
            >
              <Icon type="settlement-service" />
              <span>PLEDGE TITLE ON THIS REFERRAL</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptForTitleModal;

PromptForTitleModal.propTypes = {
  show: PropTypes.bool,
  noteStatusId: PropTypes.string.isRequired,
  acceptClose: PropTypes.func,
  dismissClose: PropTypes.func,
  matchId: PropTypes.number.isRequired,
  matchUuid: PropTypes.string.isRequired,
};
